/*******************************************
* Screen reader only helper.
*******************************************/
:host,
:host * {
  box-sizing: border-box;
}

.ace-content-loader__wrapper {
  display: flex;
  width: 100%;
}
.ace-content-loader--loading {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ace-content-loader__loaded-content.ace-content-loader__loaded-content--hidden {
  display: none;
}